// extracted by mini-css-extract-plugin
export default {"muted":"TeammateStatusLabel-module__muted--NehEq","success":"TeammateStatusLabel-module__success--e9Ex1","warning":"TeammateStatusLabel-module__warning--cD3UP"};